import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import CouponTermsData from "app/Models/Content/CouponTermsData";
import CouponTerms from './CouponTerms';
export default class CouponTermsBlock extends EpiComponent<CouponTermsData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CouponTerms context={this.getContext()} contentData={this.props.data} />;
  }
}
